import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconStar = memo(({ color = '#AAA', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M10 15.27L16.18 19 14.54 11.97 20 7.24 12.81 6.62 10 0 7.19 6.62 0 7.24 5.45 11.97 3.82 19z"
        transform="translate(2 2)"
      />
    </Svg>
  );
});
